import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationService } from 'app/modules/configuration/configuration.service';
import { GlobalService } from 'app/services/global.service';
import { PageService } from 'app/services/page-service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-verifylibrary-status',
  templateUrl: './verifylibrary-status.component.html',
  styles: [
  ]
})
export class VerifylibraryStatusComponent implements OnInit {
  @Input() data: any;
  loader = false;
  successMsg = false
  errMsg = ''
  phoneNo = "";
  libraryVerifyForm: FormGroup;
  phonePattern = environment.phonePattern
    ? environment.phonePattern
    : /^[1-9][0-9]*$/;

  loaderSendBtn = false
  libraryId = ''
  libraryDetails: any
  countryCode: any
  clientName: any
  submitted = false
  credentials: any
  libraryListByClient: any
  verified: any
  phoneNumber:any
  constructor(
    public dialogRef: NgbActiveModal,
    public global: GlobalService,
    public service: PageService,
    public fb: FormBuilder,
    public configService: ConfigurationService,
  ) { }

  ngOnInit(): void {
    // console.log(this.data)
    // console.log(this.phonePattern)
    this.libraryId = this.data['data'].libraryId
    this.countryCode = this.data['data'].countryCode
    this.clientName = this.data['data'].clientName
    this.credentials = this.data['data'].credentials
    if(this.credentials) {
      this.phoneNumber = this.removeCountryCode(this.credentials.phoneNo);
    }
    // console.log(this.libraryId, this.clientName, this.countryCode)
    if (this.data && this.data['data'] && this.data['data'].credentials) {
      var credentials = this.data['data'].credentials
    }
    // console.log(credentials)


    this.libraryVerifyForm = this.fb.group({
      senderName: [this.clientName],
      authkey: [credentials && credentials.authKey ? credentials.authKey : '', [Validators.required]],
      contactNumber: [
        credentials && credentials.phoneNo ? this.phoneNumber : '',
        [
          Validators.required,
          Validators.pattern(this.phonePattern)
        ],
      ],
      active: false,
    });
  }

  get f() {
    return this.libraryVerifyForm.controls;
  }

  close() {
    this.dialogRef.close({ success: false });
  }


  verify() {
    this.submitted = true
    this.loader = true
    if (this.libraryVerifyForm.invalid) {
      this.loader = false
      return;
    }
    const formData = this.libraryVerifyForm.value
    // if (this.data && this.data['data'] && !this.data['data'].credentials) {
    //   var contactNumber = this.countryCode + formData['contactNumber']
    // } else {
    //   var contactNumber = formData['contactNumber']

    // }
    const contactNumber = this.countryCode + formData['contactNumber']
    // console.log(contactNumber)
    const data = {
      clientName: formData['senderName'],
      credentials: {
        authKey: formData['authkey'],
        phoneNo: contactNumber
      },
      active: true
    }

    // console.log(data)

    this.configService
      .assignLibraryToClient(this.libraryId, data)
      .then((response) => {
        // console.log(response)
        this.loader = false;
        this.verifyStatus()
      })
      .catch((err) => {
        this.loader = false;
        this.global.failureErrorModal(err);
      });

  }


  verifyStatus() {
    this.loader = true
    const clientData = {
      clientName: this.clientName,
    }
    this.configService
      .getWhatsappStatus(this.libraryId, clientData)
      .then((response) => {
        // console.log(response)
        this.successMsg = true
        this.errMsg = ''
        this.loader = false
        setTimeout(() => {
          this.successMsg = false;
          this.dialogRef.close({
            success: { result: true, data: response },
          });
        }, 1000);
      })
      .catch((err) => {
        if (err) {
          this.successMsg = false;
          this.loader = false
          this.errMsg = 'Please enter valid credentials'
          this.submitted = true
          this.loader = true
          const formData = this.libraryVerifyForm.value
          const data = {
            clientName: formData['senderName'],
            credentials: {
              authKey: formData['authkey'],
              phoneNo: formData['contactNumber']
            },
            active: true,
            verified:false
          }
          // console.log(data)
          this.configService
            .assignLibraryToClient(this.libraryId, data)
            .then((response) => {
              // console.log(response)
              this.loader = false;
              setTimeout(() => {
                this.successMsg = false;
                // this.dialogRef.close({
                //   success: { result: true, data: response },
                // });
              }, 1000);
            })
            .catch((err) => {
              this.loader = false;
              this.global.failureErrorModal(err);
            });
        }
        // this.global.failureErrorModal(err);
      });
  }

  removeCountryCode(phoneNo: string): string {
    if (this.countryCode && phoneNo.startsWith(this.countryCode)) {
      return phoneNo.slice(this.countryCode.length);
    }
    return phoneNo;
  }



  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || "").trim().length === 0;
      return isWhitespace ? { whitespace: true } : null;
    };
  }

}
